export default __webpack_public_path__ + "static/media/ring.bc43959e.png";